import { loanRequestsReducer } from './loanRequests.reducer';

export default { loanRequests: loanRequestsReducer };
